import React, { createContext, useState, useContext } from "react";

// Create Context
const LoadingContext = createContext();

// Custom Hook to Use Loading Context
export const useLoading = () => {
  return useContext(LoadingContext);
};

// Provider Component
export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const showLoading = (msg) => {
    setMessage(msg);
    setLoading(true);
  };

  const hideLoading = () => {
    setLoading(false);
    setMessage("");
  };

  return (
    <LoadingContext.Provider value={{ loading, message, showLoading, hideLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
